import { ActionTree } from 'vuex'
import * as types from './mutationType'
import { RootState } from '../../types'
import { SchedulingState } from './types'
import * as api from '../../models/scheduling'

export const actions: ActionTree<SchedulingState, RootState> = {
  handler: () => {},
  test: () => {
    return true
  },
  initSetupState: ({ commit, rootState }: any) => {
    let isAdmin = rootState.auth.role !== 'Member'
    return commit(types.INIT_SETUP_STATE, isAdmin)
  },
  setDoneState: ({ commit }: any, target: any) => {
    return commit(types.SET_DONE_SETUP_STATE, target)
  },
  setSkipState: ({ commit }: any, target: any) => {
    return commit(types.SET_SKIP_SETUP_STATE, target)
  },
  setActiveState: ({ commit, getters }: any, target: string) => {
    if (target == getters.getCurrentSetupState) return false
    return commit(types.SET_ACTIVE_SETUP_STATE, {
      target,
      prev: getters.getCurrentSetupState
    })
  },
  loadDashboard: ({ commit }: any, uid: string) => {
    return api.loadDashboard(uid).then((data) => {
      return commit(types.SET_DASHBOARD, data)
    })
  },
  loadRooms: ({ commit, rootState }: any, uid: string) => {
    if (rootState.auth.role === 'Member') return
    return api.loadRoomResource(uid).then((data) => {
      return commit(types.SET_ROOMS, data)
    }).catch((err) => {
      return Promise.reject(err)
    })
  },
  saveRooms: (_: any, { uid, data }: any) => {
    return api.saveRoomSetting(uid, data)
  },
  loadCompanySetting: ({ dispatch, commit, rootState }: any, uid: string) => {
    if (rootState.auth.role === 'Member') return
    return api.loadCompanyData(uid).then((companyData) => {
      // console.log('company Data res', companyData)
      commit(types.SET_COMPANY, companyData)
      return dispatch('setTimeZone', companyData.timezone, { root: true })
    })
  },
  saveCompanySetting: async ({ state }: any, {uid, data}: any) => {
    const companyData = await {
      ...data,
      rooms: state.rooms
    }
    return api.saveCompanyData(uid, companyData)
  },
  loadUserSetting: ({ dispatch, commit }: any, uid: string) => {
    return api.loadUserSetting(uid).then((userData) => {
      commit(types.SET_USER, userData)
      return dispatch('setLanguage', userData.userLang, { root: true })
    })
  },
  saveUserSetting: ( _: any, { uid, data }: any) => {
    return api.saveUserSetting(uid, data)
  },
  loadUserList: ({ commit }: any, uid: string) => {
    return api.getUserList(uid).then((res) => {
      return commit(types.SET_USER_SETTING, res)
    })
  },
  saveUserSettingData: ( _: any, { uid, data }: any) => {
    return api.setUserSetting(uid, data)
  },
  saveUserLicense: ( _: any, { uid, userId, license }: any) => {
    return api.updateLicense(uid, String(userId), license)
  },
  saveUserRole: ( _: any, { uid, userId, role }: any) => {
    return api.updateRole(uid, String(userId), role)
  },
  saveUserStatus: ( _: any, { uid, userId, status }: any) => {
    return api.updateStatus(uid, String(userId), status)
  },
}

export default actions
